<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <br/>
                    <v-layout>
                      <v-spacer>
                      </v-spacer>
                      <v-flex xs3>
<!--                        <v-select-->
<!--                          label="Seasons"-->
<!--                          item-text="name"-->
<!--                          item-value="value"-->
<!--                          v-model="season"-->
<!--                          :items="seasons"-->
<!--                          variant="solo-filled"-->
<!--                          solo-->
<!--                          hide-checkoffSettlementDetails-->
<!--                          return-object-->
<!--                          dense-->
<!--                        ></v-select>-->
<!--                        <label class="custom-form-error grower-error" for="contract"></label>-->
                      </v-flex>
<!--                      <v-flex xs3>-->
<!--                        <v-select-->
<!--                          label="Sales"-->
<!--                          item-text="name"-->
<!--                          item-value="value"-->
<!--                          v-model="sale"-->
<!--                          :items="salesList"-->
<!--                          variant="solo-filled"-->
<!--                          solo-->
<!--                          hide-checkoffSettlementDetails-->
<!--                          return-object-->
<!--                          dense-->
<!--                        ></v-select>-->
<!--                        <label class="custom-form-error grower-error" for="contract"></label>-->
                        <v-flex xs5>
                          <v-text-field
                            label="EslipNumber"
                            v-model="eslipNumber"
                            dense
                            outlined
                            hide-details
                            solo
                            placeholder="Enter EslipNumber"
                          ></v-text-field>
<!--                          <label class="custom-form-error grower-error" for="contract"></label>-->
                        </v-flex>
<!--                      </v-flex>-->
                      <v-flex xs3>
                        <v-btn color="#7BC243" @click="getSalesReportByEslipNumber()" class="white--text cataloguebtn">Search </v-btn>
                      </v-flex>
                      <v-spacer>
                      </v-spacer>
                      <!--              <v-flex xs3>
                                      <v-text-field label="Search" v-model="search">
                                      </v-text-field>
                                    </v-flex>-->
                    </v-layout>
          <v-layout>
            <v-flex xs3>
            </v-flex>
            <v-spacer>
            </v-spacer>
            <v-flex xs3>
              <v-btn color="primary" @click="exportToExcel" style="margin-top: 10px;">Export to Excel</v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs3>
              <span class="accent--text" style="font-size: 18px; font-weight:700;"> Grower Sales Report </span>
            </v-flex>
            <v-spacer>
            </v-spacer>
            <v-flex xs3>
              <v-text-field v-model="search" append-icon="search" label="Search"
                            single-line hide-details color="primary"></v-text-field>
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="headers"
            :items="sales"
            class="elevation-1"
            :search="search"
            :options.sync="pagination"
            :items-per-page="itemsPerPage"
            :hide-default-footer="false"
            :item-key="(item, index) => index"
          >
            <template v-slot:[`header.eslipNumber`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.season`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.saleNumber`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.invoiceId`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.invoiceStatus`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.lotNumber`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.growerAmount`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.growerCode`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.brokerAmount`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.warehouseAmount`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import * as XLSX from 'xlsx'
import config from '../../../config'
import axios from 'axios'
import http from '@/http'

export default {
	name: 'growerSalesReport',
	data: function () {
		return {
			headers: [
				{ text: 'SEASON', value: 'season' },
				{ text: 'SALE NUMBER', value: 'saleNumber' },
				{ text: 'ESLIPNUMBER', value: 'eslipNumber' },
				{ text: 'INVOICE NUMBER', value: 'invoiceNumber' },
				{ text: 'INVOICE STATUS', value: 'paymentStatus' },
				{ text: 'LOTNUMBER', value: 'lotNumber' },
				{ text: 'GROWER CODE', value: 'growerCode' },
				{ text: 'GROWER NAME', value: 'growerName' },
				{ text: 'GROWER GROSS AMOUNT', value: 'growerGrossAmount' },
				{ text: 'BROKERAGE FEE', value: 'brokerAmount' },
				{ text: 'WAREHOUSE FEE', value: 'warehouseAmount' },
				{ text: 'MILLING FEE', value: 'millerAmount' },
				{ text: 'GROWER NET AMOUNT', value: 'netAmount' }
			],
			sales: [],
			message: '',
			error: '',
			loading: true,
			totalOrganizations: 0,
			snackbarColor: '',
			snackbar: false,
			permissions: [],
			search: '',
			editDialog: false,
			valid: true,
			startDateMenu: false,
			startDate: null,
			institutionTypes: [],
			e1: 1,
			currencies: [],
			page: 1,
			totalPages: 0,
			pageSize: 5,
			pageSizes: [5, 10],
			paginatedItems: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			generatedOrganizations: [],
			genpaginatedItems: [],
			genNumberOfLinks: 0,
			generatedOrganizationsPage: 1,
			sale: '',
			eslipNumber: '',
			salesList: [],
			season: '',
			seasons: []
		}
	},
	mounted () {
		this.getSeasons()
		this.getGrowerSales()
	},
	methods: {
		getGrowerSales: function () {
			const url = config.serverURI + '/reports/grower-sales-report'
			axios.get(url)
				.then(response => {
					const items = response.data
					items.forEach(item => {
						item.growerGrossAmount = this.truncateDecimal(item.growerGrossAmount)
						item.brokerAmount = this.truncateDecimal(item.brokerAmount)
						item.warehouseAmount = this.truncateDecimal(item.warehouseAmount)
						item.millerAmount = this.truncateDecimal(item.millerAmount)
						const netAmount = item.growerAmount - item.brokerAmount - item.warehouseAmount - item.millerAmount
						item.netAmount = this.truncateDecimal(netAmount)
					})
					this.sales = items
					// Truncate the growerAmount to 2 decimal places
					// this.totalPages = totalPages
				})
				.catch(error => {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
			return this.sales
		},
		exportToExcel () {
			const exportData = this.sales.map(transaction => ({
				SEASON: transaction.season,
				'SALE NUMBER': transaction.saleNumber,
				ESLIPNUMBER: transaction.eslipNumber,
				'INVOICE NUMBER': transaction.invoiceNumber,
				'INVOICE STATUS': transaction.paymentStatus,
				 LOTNUMBER: transaction.lotNumber,
				'lot Price': transaction.lotPrice,
				'settlement Type': transaction.settlementType,
				'GROWER CODE': transaction.growerCode,
				'GROWER NAME': transaction.growerName,
				'grower NonCheckoffAccount': transaction.growerNonCheckoffAccount,
				'grower NonCheckoffAccountName': transaction.growerNonCheckoffAccountName,
				'grower CheckoffAccount': transaction.growerCheckoffAccount,
				'Grower CheckoffAccountName': transaction.getGrowerCheckoffAccountName,
				'checkoff Bank Currency': transaction.checkoffBankCurrency,
				'unbulked Weight': transaction.unbulkedWeight,
				'clean Coffee Outturn': transaction.cleanCoffeeOutturn,
				parchmentWeight: transaction.parchmentWeight,
				parchmentOutTurn: transaction.parchmentOutTurn,
				growerOutTurn: transaction.growerOutTurn,
				warrantNumber: transaction.warrantNumber,
				grade: transaction.grade,
				numberOfBags: transaction.numberOfBags,
				price: transaction.price,
				weightBought: transaction.weightBought,
				brokerCode: transaction.brokerCode,
				brokerName: transaction.brokerName,
				'broker NonCheckoffAccount': transaction.brokerNonCheckoffAccount,
				'broker CheckoffAccount': transaction.brokerCheckoffAccount,
				'broker ChargeRate': transaction.brokerChargeRate,
				'GROWER GROSS AMOUNT': transaction.growerGrossAmount,
				'BROKERAGE FEE': transaction.brokerAmount,
				'WAREHOUSE FEE': transaction.warehouseAmount,
				'MILLING FEE': transaction.millerAmount,
				'GROWER NET AMOUNT': transaction.netAmount
			}))
			const worksheet = XLSX.utils.json_to_sheet(exportData)
			const workbook = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(workbook, worksheet, 'SalesData')
			const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
			this.saveExcelFile(excelBuffer, 'grower_sales_report.xlsx')
		},
		saveExcelFile (buffer, fileName) {
			const data = new Blob([buffer], { type: 'application/octet-stream' })
			const url = window.URL.createObjectURL(data)
			const a = document.createElement('a')
			a.href = url
			a.download = fileName
			a.click()
			window.URL.revokeObjectURL(url)
		},
		truncateDecimal (value) {
			if (!isNaN(value)) {
				// Check if the number is a whole number
				if (Number.isInteger(value)) {
					return value.toString() // Return as a string to avoid displaying trailing .00
				} else {
					return parseFloat(value).toFixed(2) // Truncate to 2 decimal places
				}
			}
			return value
		},
		getSeasons () {
			http.get(config.serverURI + '/miller/findSeasons')
				.then(response => {
					console.log('seasons => ', response.data)
					response.data.forEach((x) => {
						this.seasons.push({
							name: x,
							value: x
						})
					})
					this.getSales()
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		},
		getSales () {
			http.get(config.serverURI + '/miller/findSales')
				.then(response => {
					console.log('sales => ', response.data)
					response.data.forEach((x) => {
						this.salesList.push({
							name: x,
							value: x
						})
					})
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		},
		getSalesReport () {
			console.log(this.sale)
			console.log(this.season)

			if (this.sale === '' || this.season === '') {
				this.message = 'Please select both season and sale'
				this.snackbar = true
				this.snackbarColor = 'error'
				return
			}
			this.findSalesReport(this.season.name, this.sale.name)
		},
		findSalesReport (season, sale) {
			http.get(config.serverURI + '/reports/grower-sales-report-by-season-sale?season=' + season + '&sale=' + sale)
				.then(response => {
					console.log('nce-levy-report-by-filter -> ', response.data)
					const items = response.data
					items.forEach(item => {
						item.growerGrossAmount = this.truncateDecimal(item.growerGrossAmount)
						item.brokerAmount = this.truncateDecimal(item.brokerAmount)
						item.warehouseAmount = this.truncateDecimal(item.warehouseAmount)
						item.millerAmount = this.truncateDecimal(item.millerAmount)
						const netAmount = item.growerGrossAmount - item.brokerAmount - item.warehouseAmount - item.millerAmount
						item.netAmount = this.truncateDecimal(netAmount)
					})
					this.sales = items
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', {
						snackbar: true,
						color: 'error',
						message: error.response ? error.response.data.message : 'Error ocurred'
					}, { root: true })
				})
		},
		getSalesReportByEslipNumber () {
			console.log(this.eslipNumber)

			if (this.eslipNumber === '') {
				this.message = 'Please Enter eslipNumber'
				this.snackbar = true
				this.snackbarColor = 'error'
				return
			}
			this.findSalesReportByEslipNumber(this.eslipNumber)
		},
		findSalesReportByEslipNumber (eslipNumber) {
			http.get(config.serverURI + '/reports/grower-sales-report-by-eslipnumber?eslipNumber=' + eslipNumber)
				.then(response => {
					console.log('Sales Report Filter -> ', response.data)
					const items = response.data
					items.forEach(item => {
						item.growerGrossAmount = this.truncateDecimal(item.growerGrossAmount)
						item.brokerAmount = this.truncateDecimal(item.brokerAmount)
						item.warehouseAmount = this.truncateDecimal(item.warehouseAmount)
						item.millerAmount = this.truncateDecimal(item.millerAmount)
						const netAmount = item.growerGrossAmount - item.brokerAmount - item.warehouseAmount - item.millerAmount
						item.netAmount = this.truncateDecimal(netAmount)
					})
					this.sales = items
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', {
						snackbar: true,
						color: 'error',
						message: error.response ? error.response.data.message : 'Error ocurred'
					}, { root: true })
				})
		}
	}
}
</script>

<style scoped>

</style>
